import { Business } from 'modules/common/interfaces/member';

/** Retro-S opt-in is recorded by the presence of a preferred election date, not its value. */
export const hasOptedIntoRetroS = (business?: Business): boolean => Boolean(business?.preferred_s_election_date);
